<template>
  <section>
    <div class="container">
      <!-- 标题 -->
      <div class="home_title">
        <div class="left">
          <h1><i>P</i>RODUCTS</h1>
          <!-- <p>产品中心</p> -->
        </div>
        <router-link class="more iconfont icon-jiantou b" :to="{ path: '/product' }">MORE</router-link>
      </div>

      <!-- tab -->
      <div class="cate">
        <div class="tab_list">
          <div v-for="(item, index) in list" :key="index" class="tab_item" :class="{ active: activeIndex == index }"
            @click="activeIndex = index">
            {{ item.cat_name }}
          </div>
        </div>
        <div class="right">
          <ProductList :list="list[activeIndex]?.prolist" :loading="false"></ProductList>
        </div>
      </div>
    </div>
  </section>

  <section class="swiper cace_swiper">
    <div class="swiper-wrapper">
      <div v-for="item in cases" :key="item.id" class="swiper-slide">
        <div class="inner"></div>
        <img :src="$baseURL + item.thumb" width="100%" />
        <div class="info">
          <h4>{{ item.title }}</h4>
          <router-link :to="{ path: '/case/info', query: { id: item.id } }" class="more iconfont icon-jiantou">
            MORE
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import "swiper/swiper.min.css";
import Swiper from "swiper";

export default {
  props: {
    list: {
      type: Array,
    },
    cases: {
      type: Array,
    },
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
  mounted() {
    this.onSwiper();
  },
  methods: {
    onSwiper() {
      new Swiper(".cace_swiper", {
        loop: true,
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        speed: 1000,
        autoplay: {
          delay: 1000,
        },
        breakpoints: {
          480: {
            slidesPerView: 2.2,
          },
          780: {
            slidesPerView: 3.2,
          },
          1030: {
            slidesPerView: 4.2,
          },
          1280: {
            slidesPerView: 4.5,
          },
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.cate {
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
  background-image: url(../../assets/image/product_bg.svg);
  background-repeat: no-repeat;

  .tab_list {
    margin-right: 100px;

    .tab_item {
      margin-bottom: 60px;
      padding: 7px 30px;
      border-radius: 22px;
      font-size: 20px;
      white-space: nowrap;
      cursor: pointer;

      &.active {
        color: #fff;
        background: var(--themeColor);
        position: relative;

        &::after {
          content: "";
          background: var(--themeColor2);
          width: 10px;
          height: 10px;
          border-radius: 50%;
          position: absolute;
          left: -5px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }

  .right {
    flex: 1;
  }
}

.cace_swiper {
  .swiper-slide {
    position: relative;

    .inner {
      position: absolute;
      opacity: 1;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      margin: auto;
      background: rgba(0, 0, 0, .3);
      transition: all 0.3s;
    }

    img {
      display: block;
      width: 100%;
    }

    .info {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;

      h4 {
        white-space: nowrap;
        font-size: 20px;
        color: #fff;
        margin-bottom: 20px;
        transform: translateY(20px);
        transition: all 0.3s;
      }

      .more {
        transform: translateY(20px);
        opacity: 0;
        transition: all 0.3s;
      }
    }

    &:hover {
      .inner {
        background-color: rgba(0, 0, 0, .8);
      }

      h4 {
        transform: none;
      }

      .more {
        opacity: 1;
        transform: none;
      }
    }
  }
}

@media (max-width: 1450px) {
  .cate {
    .tab_list {
      margin-right: 50px;
    }
  }
}

@media (max-width: 1250px) {
  .cate {
    display: block;

    .tab_list {
      margin-right: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .tab_item {
        padding: 5px 15px;
        font-size: 14px;
        margin-bottom: 20px;
      }
    }
  }
}

@media (max-width: 850px) {
  .cace_swiper {
    .swiper-slide {
      .info {
        h4 {
          transform: none;
        }

        .more {
          opacity: 1;
          transform: none;
        }
      }
    }
  }
}
</style>